module.exports = __webpack_public_path__ + "img/404-studio7.9b038ccd.svg";